/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration for Showdown (MATCH_RESULT) strategy
 * @export
 * @interface ShowdownConfig
 */
export interface ShowdownConfig {
    /**
     * Whether showdown mode is enabled
     * @type {boolean}
     * @memberof ShowdownConfig
     */
    enabled?: boolean;
    /**
     * EventType that determines match outcome
     * @type {string}
     * @memberof ShowdownConfig
     */
    winEventTypeId?: string;
    /**
     * Win event name for display
     * @type {string}
     * @memberof ShowdownConfig
     */
    winEventTypeName?: string;
    /**
     * JSON Logic condition for what counts as a win
     * @type {object}
     * @memberof ShowdownConfig
     */
    winCondition?: object;
}

/**
 * Check if a given object implements the ShowdownConfig interface.
 */
export function instanceOfShowdownConfig(value: object): value is ShowdownConfig {
    return true;
}

export function ShowdownConfigFromJSON(json: any): ShowdownConfig {
    return ShowdownConfigFromJSONTyped(json, false);
}

export function ShowdownConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowdownConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'winEventTypeId': json['winEventTypeId'] == null ? undefined : json['winEventTypeId'],
        'winEventTypeName': json['winEventTypeName'] == null ? undefined : json['winEventTypeName'],
        'winCondition': json['winCondition'] == null ? undefined : json['winCondition'],
    };
}

export function ShowdownConfigToJSON(json: any): ShowdownConfig {
    return ShowdownConfigToJSONTyped(json, false);
}

export function ShowdownConfigToJSONTyped(value?: ShowdownConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'winEventTypeId': value['winEventTypeId'],
        'winEventTypeName': value['winEventTypeName'],
        'winCondition': value['winCondition'],
    };
}

